import React, { ReactElement } from 'react';

import HCaptcha from '@hcaptcha/react-hcaptcha';

import constants from '@/utils/constants';

import styles from './HCaptcha.module.scss';

interface HCaptchaProps {
	hCaptchaRef: React.RefObject<HCaptcha> | undefined;
	onVerify: (token: string) => void;
	onClose?: () => void;
}

const { HCAPTCHA_SITE_KEY, HCAPTCHA_SCRIPT_SOURCE, HCAPTCHA_HOST } = constants;

const HCaptchaComponent: React.FC<HCaptchaProps> = (
	props: HCaptchaProps,
): ReactElement => {
	const { hCaptchaRef, onVerify, onClose } = props;

	return (
		<div className={styles.captchaHolder}>
			<HCaptcha
				ref={hCaptchaRef}
				size="invisible"
				sitekey={HCAPTCHA_SITE_KEY}
				onVerify={onVerify}
				onClose={onClose}
				scriptSource={HCAPTCHA_SCRIPT_SOURCE}
				// eslint-disable-next-line @typescript-eslint/ban-ts-comment
				// @ts-ignore
				apihost={HCAPTCHA_HOST}
				assethost={HCAPTCHA_HOST}
				endpoint={HCAPTCHA_HOST}
			/>
		</div>
	);
};

export default HCaptchaComponent;
